export enum LogLevel {
  ALL = 0,
  INFO,
  WARN,
  ERROR,
  OFF,
}
